<div class="container" *ngIf="!isLoading">
    <div class="header">
        <div class="button" (click)="printGroups()" [class.disable]="!reposeGroupList?.length">
            {{ 'repose-group.page.print-button' | translate }}
        </div>
    </div>

    <div class="content">
        <div class="table">
            <div class="table-header">
                <div class="header-td group-id-header" data-cy="repose-table-group-no-label">
                    {{ 'repose-group.page.table.header.num' | translate }}
                </div>
                <div class="header-td name-header" data-cy="repose-table-group-name-label">
                    {{ 'repose-group.page.table.header.name' | translate }}
                </div>
                <div class="header-td trigger-channel-header" data-cy="repose-table-channel-label">
                    {{ 'repose-group.page.table.header.trigger-channel' | translate }}
                </div>
                <div class="header-td delay-on-header" data-cy="repose-table-on-delay-label">
                    {{ 'repose-group.page.table.header.delay-on' | translate }}
                </div>
                <div class="header-td delay-off-header" data-cy="repose-table-off-delay-label">
                    {{ 'repose-group.page.table.header.delay-off' | translate }}
                </div>
            </div>

            <div class="table-content">
                <div
                    class="tabl-data"
                    cdkDropList
                    [cdkDropListData]="reposeGroupList"
                    (cdkDropListDropped)="reposeGroupDrop($event)">
                    <div class="no-data" *ngIf="!reposeGroupList?.length">
                        {{ 'repose-group.page.no-data-message' | translate }}
                    </div>
                    <app-repose-row
                        class="table-row"
                        *ngFor="let reposeGroup of reposeGroupList; let index = index"
                        cdkDrag
                        [cdkDragDisabled]="!reposeGroupPageEditMode"
                        [reposeGroup]="reposeGroup"
                        [reposeGroupEditMode]="reposeGroupPageEditMode"
                        [index]="index"
                        [reposeGroupList]="reposeGroupList"
                        [userCanEdit]="userCanEdit"
                        (onDeleteRow)="deleteRow(index)"
                        (onRowUpdated)="onGroupUpdated($event)"></app-repose-row>
                </div>
                <div class="add-row-container">
                    <button
                        class="add-row-button"
                        data-cy="repose-create-repose-group-button"
                        *ngIf="!reposeGroupPageEditMode"
                        (click)="openCreateDialog()"
                        [disabled]="!userCanEdit">
                        {{ 'repose-group.page.footer.add' | translate }}
                    </button>
                    <div class="count-text">
                        {{ 'repose-group.page.group-count-text' | translate: { count: reposeGroupList.length } }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div *ngIf="isLoading" class="loading-container">
    <app-loading-spinner [custom]="true" class="spinner-component" size="80" strokeWidth="3"></app-loading-spinner>
</div>
